export const ROUTES = {
  HOME: "/",
  ADMIN_LOGIN: "/admin/login",
  ADMIN_DASHBOARD: "/admin/dashboard",
  AREE: "/aree",
  FOOD: "/food",
  ESCAPE_TOWER: "/escape-tower",
  TORNEI: "/tornei",
  RADUNO_GENSHIN: "/raduno-genshin-impact",
  FAQ: "/faq",
  PROGRAMMA: "/programma",
};
